import { ReactNode, createContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { updateCurrentRoute } from 'src/redux/actions/system';

function getVisitedRoutesFromStorage(): string[] {
  return JSON.parse(sessionStorage.getItem('visitedRoutes') || '[]');
}

function updateVisitedRoutesInStorage(newVisitedRoutes: string[]) {
  sessionStorage.setItem('visitedRoutes', JSON.stringify(newVisitedRoutes));
}

interface RoutesRecorderContext {
  visitedRoutes: string[];
}
export const routesRecorderContext =
  createContext<RoutesRecorderContext | null>(null);

interface RoutesRecorderProviderProps {
  children: ReactNode;
}
export const RoutesRecorderProvider = ({
  children,
}: RoutesRecorderProviderProps) => {
  const [visitedRoutes, setVisitedRoutes] = useState(() =>
    getVisitedRoutesFromStorage(),
  );
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const currentRoute = location.pathname;
    const currentRouteSearchParams = location.search;

    dispatch(updateCurrentRoute(`${currentRoute}${currentRouteSearchParams}`));

    const isDuplicateEntry =
      visitedRoutes[visitedRoutes.length - 1] === currentRoute;
    if (isDuplicateEntry ?? currentRoute === '/') {
      return;
    }

    setVisitedRoutes((prevVisitedRoutes) => {
      const newVisitedRoutes = [...prevVisitedRoutes, currentRoute];
      updateVisitedRoutesInStorage(newVisitedRoutes);
      return newVisitedRoutes;
    });
    /*
     * We only want to run this effect when the location changes, not when the
     * visitedRoutes state changes. The visitedRoutes state is only updated
     * when the location changes, so we can safely ignore it in the dependency
    */
   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);

  const contextValue = {
    visitedRoutes,
  };

  return (
    <routesRecorderContext.Provider value={contextValue}>
      {children}
    </routesRecorderContext.Provider>
  );
};
